import React from 'react'
import ColumnFlexBox from './ColumnFlexBox'
import FlexBox from './FlexBox'

const BrandIndex = ({name = '', index = 0}) => {
  const logoClass = `brand-logo ${name}`
  return (
    <ColumnFlexBox className='brand-container' width='initial'>
      <FlexBox className={logoClass} />
      <FlexBox className='brand-index'>{index}</FlexBox>
    </ColumnFlexBox>
  )
}

export default BrandIndex



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/BrandIndex.js